/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.signature.defs'

export { $nsid }

type SigDetail = {
  $type?: 'tools.ozone.signature.defs#sigDetail'
  property: string
  value: string
}

export type { SigDetail }

const sigDetail = l.typedObject<SigDetail>(
  $nsid,
  'sigDetail',
  l.object({ property: l.string(), value: l.string() }),
)

export { sigDetail }
